module.exports = __webpack_public_path__ + "img/7.78d9c184.svg";